<template>
  <div class="explain-phone-type__container">
    <div class="explain-phone-type__close-icon">
      <div style="cursor: pointer" @click.prevent="closeExplainPhoneTypeModal">
        <IconCross color="#f37053" size="25px" />
      </div>
    </div>
    <div class="explain-phone-type__title">
      {{ $t('product_form.device_type_modal.title') }}
    </div>
    <p class="explain-phone-type__subtitle">
      {{ $t('product_form.device_type_modal.subtitle') }}
    </p>
    <div class="explain-phone-type__wrapper-container">
      <div class="explain-phone-type__wrapper">
        <div class="explain-phone-type__gallery">
          <div
            v-for="(item, index) in instructionsItems"
            :key="index"
            class="explain-phone-type__item"
          >
            <div class="explain-phone-type__item-step">
              <span class="explain-phone-type__item-step__number">
                {{ index + 1 }}</span
              >
              <span class="explain-phone-type__item-title">
                {{ item.title }}</span
              >
            </div>
            <p
              class="explain-phone-type__item-description"
              v-html="item.description"
            ></p>
            <img
              class="explain-phone-type__item-image"
              :src="item.image"
              :alt="item.title"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconCross from '~/components/icons/cross/Cross.vue'

export default {
  components: {
    IconCross,
  },
  data() {
    return {
      showExplainPhoneType: false,
    }
  },
  computed: {
    instructionsItems() {
      const instructionsItems = [
        {
          title: this.$t('product_form.device_type_modal.step_1.title'),
          description: this.$t(
            'product_form.device_type_modal.step_1.description'
          ),
          image: this.$isBrStore
            ? 'https://static-goengines.gocase.com.br/qr-img/89484123967227711695919971757.png'
            : 'https://static-goengines.gocase.com.br/qr-img/68133171245734391695932326501.png',
        },
        {
          title: this.$t('product_form.device_type_modal.step_2.title'),
          description: this.$t(
            'product_form.device_type_modal.step_2.description'
          ),
          image: this.$isBrStore
            ? 'https://static-goengines.gocase.com.br/qr-img/82920829664299631695920128403.png'
            : 'https://static-goengines.gocase.com.br/qr-img/53349429000164591695932345619.png',
        },
        {
          title: this.$t('product_form.device_type_modal.step_3.title'),
          description: this.$t(
            'product_form.device_type_modal.step_3.description'
          ),
          image: this.$isBrStore
            ? 'https://static-goengines.gocase.com.br/qr-img/60410889049734151695920144168.png'
            : 'https://static-goengines.gocase.com.br/qr-img/75930558359163421695932361165.png',
        },
      ]

      return instructionsItems
    },
  },
  methods: {
    closeExplainPhoneTypeModal() {
      this.$emit('closeModal')
    },
  },
}
</script>

<style lang="scss">
.explain-phone-type__container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fcfdf7;
  border-radius: 7px;
  padding: 20px;
  z-index: 105;
  width: 100%;
  max-height: 90%;
  max-width: 350px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
}

.explain-phone-type__title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #f37053;
}

.explain-phone-type__subtitle {
  font-size: 15px;
  font-weight: 400;
  text-align: center;
}

.explain-phone-type__wrapper-container
  .explain-phone-type__wrapper
  .explain-phone-type__gallery
  .explain-phone-type__item {
  flex-shrink: 1;
}

.explain-phone-type__close-icon {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.explain-phone-type__wrapper-container {
  position: relative;
}

.explain-phone-type__wrapper::-webkit-scrollbar {
  display: none;
}

.explain-phone-type__wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.explain-phone-type__wrapper {
  overflow-x: auto;
}

.explain-phone-type__gallery {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  grid-gap: 15px;
  gap: 15px;
}

.explain-phone-type__item {
  flex-shrink: 0;
  padding: 15px;
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  border: 2px solid #ffede9;
  background-color: #fff;
  border-radius: 5px;
  font-weight: 700;
  transition: border-color 0.3s;
}

.explain-phone-type__item-description {
  font-size: 13px;
  font-weight: normal;
  margin-bottom: 20px;
}

.explain-phone-type__item-image {
  border-radius: 5px;
  height: 300px;
  object-fit: contain;
  margin-top: auto;
  scale: 1;
}

.explain-phone-type__item-title {
  font-size: 15px;
}

.explain-phone-type__item-step {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 10px;
}

.explain-phone-type__item-step__number {
  background-color: #f37053;
  color: #fff;
  display: flex;
  border-radius: 9999px;
  overflow: hidden;
  width: 1.75rem;
  height: 1.75rem;
  justify-content: center;
  align-items: center;
}

@media (max-width: 390px) {
  .explain-phone-type__container {
    max-width: 330px;
  }
}

@media (max-width: 370px) {
  .explain-phone-type__container {
    max-width: 300px;
  }
}

@media (min-width: 768px) {
  .explain-phone-type__container {
    max-width: 1152px;
  }

  .explain-phone-type__item-description {
    font-size: 15px;
  }

  .explain-phone-type__wrapper-container {
    margin: 0;
  }

  .explain-phone-type__gallery {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  .explain-phone-type__title {
    font-size: 24px;
  }

  .explain-phone-type__subtitle {
    font-size: 20px;
    margin: 14px 0px 25px 0px;
  }

  .explain-phone-type__item-title {
    font-size: 16px;
  }

  .explain-phone-type__container {
    padding-bottom: 40px;
  }

  .explain-phone-type__item-image {
    height: 300px;
  }

  .explain-phone-type__container {
    max-height: 640px;
  }
}
</style>
